import Anime from "./anime";

export default Anime;
